<template>
  <v-form ref="featureIntersectionDetailsForm" v-model="validDetails" class="mt-2">
    <v-row>
      <v-col xs="12" sm="12" md="12" lg="6" class="pa-0">
        <LabelSelect
          :labelXl="6"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :selectXl="6"
          :selectLg="6"
          :selectMd="6"
          :selectSm="6"
          :id="`label_Highway_On/Under_${rowId}`"
          label="F.02 On/Under"
          :refTable="REFERENCE_TABLE.ON_UNDER"
          v-model="selectedRow.onUnder"
        >
        </LabelSelect>
        <LabelSelect
          :labelXl="6"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :selectXl="6"
          :selectLg="6"
          :selectMd="6"
          :selectSm="6"
          :id="`label_Highway_Feature_Type_${rowId}`"
          label="F.03 Feature Type"
          :refTable="REFERENCE_TABLE.FEATURE_TYPE"
          v-if="$vuetify.display.mdAndDown"
          v-model="selectedRow.featureType"
        >
        </LabelSelect>

        <LabelText
          :labelXl="6"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :textXl="6"
          :textLg="6"
          :textMd="6"
          :textSm="6"
          :id="`txt_Feature_Name_${rowId}`"
          label="B.F.03 Feature Name"
          v-model="selectedRow.roadwayName"
          maxlength="30"
          type="textarea"
        >
        </LabelText>

        <LabelText
          :labelXl="6"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :textXl="6"
          :textLg="6"
          :textMd="6"
          :textSm="6"
          :id="`txt_County_${rowId}`"
          label="RT.11 County"
          v-model="highwayCountyValue"
        >
        </LabelText>

        <LabelText
          :labelXl="6"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :textXl="6"
          :textLg="6"
          :textMd="6"
          :textSm="6"
          :id="`txt_State_Route_Number_${rowId}`"
          label="RT.12 State Route Number"
          v-model="selectedRow.srNum"
          maxlength="4"
        >
        </LabelText>
        <LabelText
          :labelXl="6"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :textXl="6"
          :textLg="6"
          :textMd="6"
          :textSm="6"
          :id="`txt_Segment_${rowId}`"
          label="RT.13 Segment"
          v-model="selectedRow.segNum"
          maxlength="4"
        >
        </LabelText>
        <LabelText
          :labelXl="6"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :textXl="6"
          :textLg="6"
          :textMd="6"
          :textSm="6"
          :id="`txt_Offset_${rowId}`"
          label="RT.14 Offset"
          v-model="selectedRow.offset"
          maxlength="4"
        >
        </LabelText>

        <LabelText
          :labelXl="6"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :textXl="6"
          :textLg="6"
          :textMd="6"
          :textSm="6"
          :id="`txt_Route_#_${rowId}`"
          label="B.RT.02 Route #"
          v-model="selectedRow.routeNum"
        >
        </LabelText>

        <LabelSelect
          :labelXl="6"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :selectXl="6"
          :selectLg="6"
          :selectMd="6"
          :selectSm="6"
          :id="`label_Direction_${rowId}`"
          label="B.RT.03 Direction"
          :refTable="REFERENCE_TABLE.FEATURE_ROUTE_DIRECTION"
          v-model="selectedRow.routeDir"
        >
        </LabelSelect>

        <LabelSelect
          :labelXl="6"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :selectXl="6"
          :selectLg="6"
          :selectMd="6"
          :selectSm="6"
          :id="`label_Functional_Class_${rowId}`"
          label="B.H.01 Functional Class"
          :refTable="REFERENCE_TABLE.ROADWAY_FUNCTIONAL_CLASSIFICATION"
          v-model="selectedRow.funcClass"
        >
        </LabelSelect>
        <LabelSelect
          :labelXl="6"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :selectXl="6"
          :selectLg="6"
          :selectMd="6"
          :selectSm="6"
          :id="`label_Nat_Hwy_Sys_${rowId}`"
          label="B.H.03 Nat Hwy Sys"
          :refTable="REFERENCE_TABLE.NATIONAL_HIGHWAY_SYSTEM"
          v-model="selectedRow.nhsInd"
        >
        </LabelSelect>
        <LabelText
          :labelXl="6"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :textXl="6"
          :textLg="6"
          :textMd="6"
          :textSm="6"
          :id="`txt_Lanes_${rowId}`"
          label="B.H.08 Lanes"
          v-model="selectedRow.lanes"
          type="number"
        >
        </LabelText>
        <LabelText
          :labelXl="6"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :textXl="6"
          :textLg="6"
          :textMd="6"
          :textSm="6"
          :id="`txt_Median_${rowId}`"
          label="RT.02 Medians"
          v-model="selectedRow.numMedian"
          type="number"
        >
        </LabelText>
        <LabelText
          :labelXl="6"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :textXl="6"
          :textLg="6"
          :textMd="6"
          :textSm="6"
          :id="`txt_Speed_${rowId}`"
          label="RT.03 Speed"
          v-model="selectedRow.roadSpeed"
          noNegativeDisplayed
          appendWith=" mph"
          type="number"
        >
        </LabelText>

        <LabelText
          :labelXl="6"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :textXl="6"
          :textLg="6"
          :textMd="6"
          :textSm="6"
          :id="`txt_Recent_ADT_${rowId}`"
          label="B.H.09 Recent ADT"
          v-model="selectedRow.adtTotal"
          type="number"
        >
        </LabelText>

        <LabelText
          :labelXl="6"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :textXl="6"
          :textLg="6"
          :textMd="6"
          :textSm="6"
          :id="`txt_Year_${rowId}`"
          label="B.H.11 Year"
          v-model="selectedRow.adtYear"
        >
        </LabelText>
        <LabelText
          :labelXl="6"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :textXl="6"
          :textLg="6"
          :textMd="6"
          :textSm="6"
          :id="`txt_Truck_ADT_${rowId}`"
          label="H.07 Truck % ADT"
          v-model="selectedRow.truckPct"
          type="number"
        >
        </LabelText>
        <LabelText
          :labelXl="6"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :textXl="6"
          :textLg="6"
          :textMd="6"
          :textSm="6"
          :id="`txt_ADTT_${rowId}`"
          label="B.H.10 ADTT"
          v-model="selectedRow.adtt"
          type="number"
        >
        </LabelText>

        <LabelText
          :labelXl="6"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :textXl="6"
          :textLg="6"
          :textMd="6"
          :textSm="6"
          :id="`txt_ADTT_Year_${rowId}`"
          label="H.08 ADTT Year"
          v-model="selectedRow.adttYear"
        >
        </LabelText>
      </v-col>

      <v-col class="pa-0">
        <LabelCheckbox
          labelXl="6"
          labelLg="6"
          labelMd="6"
          labelSm="6"
          editIndent
          class="labelCheckbox"
          :id="`checkbox_New Wear Surface Ind_${rowId}`"
          label="RT.25 New Wear Surface Ind"
          v-model="structureNewWearSurface"
          :isEditable="isEditable && !readOnly"
          @update:modelValue="changesDetectedHighway = true"
        >
        </LabelCheckbox>

        <LabelText
          :labelXl="6"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :textXl="6"
          :textLg="6"
          :textMd="6"
          :textSm="6"
          :id="`txt_Horizontal_(L)_${rowId}`"
          label="B.H.14 Horizontal (L)"
          v-model="selectedRow.totHorClearLeft"
          appendWith=" ft"
          :decimalPlaces="2"
          type="number"
        >
        </LabelText>
        <LabelText
          :labelXl="6"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :textXl="6"
          :textLg="6"
          :textMd="6"
          :textSm="6"
          :id="`txt_Horizontal_(R)_${rowId}`"
          label="B.H.15 Horizontal (R)"
          v-model="selectedRow.totHorClearRight"
          appendWith=" ft"
          :decimalPlaces="2"
          type="number"
        >
        </LabelText>
        <LabelText
          :labelXl="6"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :textXl="6"
          :textLg="6"
          :textMd="6"
          :textSm="6"
          :id="`txt_Min_Vertical_(L)_${rowId}`"
          label="H.15 Min Vertical (L)"
          v-model="selectedRow.minOverVertClearLeft"
          appendWith=" ft"
          :decimalPlaces="2"
          type="number"
        >
        </LabelText>
        <LabelText
          :labelXl="6"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :textXl="6"
          :textLg="6"
          :textMd="6"
          :textSm="6"
          :id="`txt_Min_Vertical _(R)_${rowId}`"
          label="H.16 Min Vertical (R)"
          v-model="selectedRow.minOverVertClearRight"
          appendWith=" ft"
          :decimalPlaces="2"
          type="number"
        >
        </LabelText>
        <LabelText
          :labelXl="6"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :textXl="6"
          :textLg="6"
          :textMd="6"
          :textSm="6"
          :id="`txt_Defense_Vertical_(L)_${rowId}`"
          label="H.17 Defense Vertical (L)"
          v-model="selectedRow.defVertClearLeft"
          appendWith=" ft"
          :decimalPlaces="2"
          type="number"
        >
        </LabelText>
        <LabelText
          :labelXl="6"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :textXl="6"
          :textLg="6"
          :textMd="6"
          :textSm="6"
          :id="`txt_Defense_Vertical_(R)_${rowId}`"
          label="H.18 Defense Vertical (R)"
          v-model="selectedRow.defVertClearRight"
          appendWith=" ft"
          :decimalPlaces="2"
          type="number"
        >
        </LabelText>

        <LabelSelect
          :labelXl="6"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :selectXl="6"
          :selectLg="6"
          :selectMd="6"
          :selectSm="6"
          :id="`label_Highway_Feature_Type_${rowId}`"
          label="F.03 Feature Type"
          v-if="$vuetify.display.lgAndUp"
          :refTable="REFERENCE_TABLE.FEATURE_TYPE"
          v-model="selectedRow.featureType"
        >
        </LabelSelect>

        <LabelSelect
          :labelXl="6"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :selectXl="6"
          :selectLg="6"
          :selectMd="6"
          :selectSm="6"
          :id="`label_6C35_Vertical_Clearance_Sign_(L)_${rowId}`"
          label="H.19 Vertical Clearance Sign (L)"
          :refTable="REFERENCE_TABLE.VERTICAL_CLEARANCE_SIGN"
          :isEditable="isEditable && !readOnly"
          v-model="selectedRow.vertClearSign"
          @update:modelValue="changesDetectedHighway = true"
        >
        </LabelSelect>

        <v-row>
          <v-col sm="6"><v-label class="bold">H.20 Vertical Clearance Posting (L):</v-label></v-col>
          <v-col sm="3" md="3" lg="3" xl="3">
            <LabelText
              :id="`txt_Vert_Clear_Posting_(L)_ft_${rowId}`"
              label=""
              v-model="selectedRow.vrtClrPostLeftFt"
              appendWith=" ft"
              noGrid
              type="number"
              :counter="null"
              :showColon="false"
              maxlength="2"
              :rules="
                isEditable
                  ? [
                      (value) => {
                        return lessThanValueRule(value, 16);
                      },
                    ]
                  : []
              "
              @update:modelValue="changesDetectedHighway = true"
              :isEditable="!readOnly"
              noExtraPadding
              textStyle="width:100%"
            ></LabelText>
          </v-col>
          <v-col sm="3" md="3" lg="3" xl="3">
            <LabelText
              :id="`txt_Vert_Clear_Posting_(L)_in_${rowId}`"
              label=""
              v-model="selectedRow.vrtClrPostLeftInch"
              appendWith=" in"
              noGrid
              type="number"
              :counter="null"
              :showColon="false"
              maxlength="2"
              :rules="
                isEditable
                  ? [
                      (value) => {
                        return lessThanValueRule(value, 11);
                      },
                    ]
                  : []
              "
              @update:modelValue="changesDetectedHighway = true"
              :isEditable="!readOnly"
              noExtraPadding
              textStyle="width:100%"
            ></LabelText>
          </v-col>
        </v-row>

        <LabelSelect
          :labelXl="6"
          :labelLg="6"
          :labelMd="6"
          :labelSm="6"
          :selectXl="6"
          :selectLg="6"
          :selectMd="6"
          :selectSm="6"
          :id="`label_Vertical_Clearance_Sign_(R)_${rowId}`"
          label="H.21 Vertical Clearance Sign (R)"
          :refTable="REFERENCE_TABLE.VERTICAL_CLEARANCE_SIGN"
          :isEditable="isEditable && !readOnly"
          v-model="selectedRow.vrtClearSignR"
          @update:modelValue="changesDetectedHighway = true"
        >
        </LabelSelect>

        <v-row>
          <v-col sm="6"><v-label class="bold">H.22 Vertical Clearance Posting (R):</v-label></v-col>
          <v-col sm="3" md="3" lg="3" xl="3">
            <LabelText
              :id="`txt_Vert_Clear_Posting_(R)_ft_${rowId}`"
              label=""
              v-model="selectedRow.vrtClrPostRightFt"
              appendWith=" ft"
              noGrid
              type="number"
              :counter="null"
              :showColon="false"
              maxlength="2"
              :rules="
                isEditable
                  ? [
                      (value) => {
                        return lessThanValueRule(value, 16);
                      },
                    ]
                  : []
              "
              @update:modelValue="changesDetectedHighway = true"
              :isEditable="!readOnly"
              noExtraPadding
              textStyle="width:100%"
            ></LabelText>
          </v-col>
          <v-col sm="3" md="3" lg="3" xl="3">
            <LabelText
              :id="`txt_Vert_Clear_Posting_(R)_in_${rowId}`"
              label=""
              v-model="selectedRow.vrtClrPostRightInch"
              appendWith=" in"
              noGrid
              type="number"
              :counter="null"
              :showColon="false"
              maxlength="2"
              :rules="
                isEditable
                  ? [
                      (value) => {
                        return lessThanValueRule(value, 11);
                      },
                    ]
                  : []
              "
              @update:modelValue="changesDetectedHighway = true"
              :isEditable="!readOnly"
              noExtraPadding
              textStyle="width:100%"
            ></LabelText>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { ref, computed, watch } from "vue";
import { REFERENCE_TABLE } from "@/constants/ReferenceTables";
import { useInspectionStore } from "@/stores/inspection";
import LabelSelect from "@/components/common/LabelSelect.vue";
import LabelCheckbox from "@/components/common/LabelCheckbox.vue";
import LabelText from "@/components/common/LabelText.vue";
import { lessThanValueRule } from "@/composables/validationRules";
import useFeaturesData from "@/composables/featuresData";
import { ROUNDING_FACTOR } from "@/constants/RoundingFactors";

export default {
  name: "InspectionFeaturesHighway",
  props: {
    rowId: { default: 0 },
    readOnly: { default: false },
  },
  emits: ["changesDetectedHighway", "updatedNewWearSurface"],
  setup(props, context) {
    const inspectionStore = useInspectionStore();
    const isEditable = computed(() => {
      return inspectionStore.isEditable;
    });

    const { highwayCounty } = useFeaturesData();

    let selectedRow = computed(() => inspectionStore.getFeatureIntersectionSelectedRow(props.rowId));

    const highwayCountyValue = highwayCounty(selectedRow.value);

    let validDetails = ref(false);

    let featureIntersectionDetailsForm = ref(null);

    async function validate() {
      await featureIntersectionDetailsForm.value.validate();
      return validDetails.value;
    }
    let structure = computed(() => inspectionStore.selectedInspection);
    let localStructureNewWearSurface = ref(structure.value.userInspection.newWs);
    let changesDetectedHighway = ref(false);
    let isStructureNewWearSurfaceChecked = ref(false);
    let structureNewWearSurface = computed({
      get: () => {
        return localStructureNewWearSurface.value;
      },
      set: (value) => {
        localStructureNewWearSurface.value = value;
        context.emit("updatedNewWearSurface", value);
      },
    });

    watch(
      () => [changesDetectedHighway],
      () => {
        context.emit("changesDetectedHighway", changesDetectedHighway.value);
      },
      { deep: true },
    );

    return {
      validate,
      featureIntersectionDetailsForm,
      validDetails,
      REFERENCE_TABLE,
      isEditable,
      structure,
      changesDetectedHighway,
      selectedRow,
      ROUNDING_FACTOR,
      highwayCountyValue,
      lessThanValueRule,
      isStructureNewWearSurfaceChecked,
      structureNewWearSurface,
    };
  },
  components: {
    LabelSelect,
    LabelCheckbox,
    LabelText,
  },
};
</script>
<style scoped lang="scss">
th {
  text-align: center;
}

.details-text :deep(.v-input__details) {
  padding-left: 0;
}
</style>
